import { render } from "./AgendaRemoveModal.vue?vue&type=template&id=09f76e86"
import script from "./AgendaRemoveModal.vue?vue&type=script&lang=js"
export * from "./AgendaRemoveModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/api-staging.champagne-booking.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__